/* eslint-disable prettier/prettier */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSmile, faFrown } from '@fortawesome/fontawesome-free-solid';
import './feedBack.css';
import { useState } from 'react';
import { SectionHeadingSmall } from '../Headings';

function FeedBack() {
  return (
    <div className="feedBack">
      <SectionHeadingSmall text="Feedback :" />
      <FeedbackButton icon={faSmile} color="#fcc900" bgColor="#212529" />
      <FeedbackButton icon={faFrown} color="#fcc900" bgColor="#212529" />
    </div>
  );
}

function FeedbackButton({
  icon,
  color = '',
  bgColor = '',
  callBackFunction = ''
}) {
  const [defaultColor] = useState('#212529');
  const [defaultBgColor] = useState('#e2e2e2');
  const [style, setStyle] = useState({
    color: defaultColor
  });

  const [styleBtn, setStyleBtn] = useState({
    backgroundColor: defaultBgColor
  });

  const reset = () => {
    setStyle({ color: defaultColor });
    setStyleBtn({ backgroundColor: defaultBgColor });
  };

  return (
    <button
      type="button"
      style={{ ...styleBtn }}
      onClick={() => {
        if (
          style.color === defaultColor && styleBtn.backgroundColor === defaultBgColor
        ) {
          setStyle({ color });
          setStyleBtn({ backgroundColor: bgColor });
        } else {
          reset();
        }
        if (callBackFunction && typeof callBackFunction === 'function') {
          callBackFunction();
        }
      }}
    >
      <FontAwesomeIcon style={{ ...style }} icon={icon} />
    </button>
  );
}

export default FeedBack;
